// write constant string

import Images from "./images";

export const constant = {
  errorMessage: {
    require: "field is required",
    string: "value must be string",
    email: "please enter valid email",
    password: "Password must be at least 6 alphanumeric characters",
  },
  authModalType: {
    LoginSignUp: "LoginSignUp",
    Login: "Login",
    Signup: "Signup",
    Forgot: "Forgot",
    ForgotConfirmPsw: "ForgotConfirmPsw",
    ForgotOtpVerify: "ForgotOtpVerify",
    Intrest: "Intrest",
    UploadProfile: "UploadProfile",
    OtpVerification: "OtpVerification",
    SelectPersonaModal: "SelectPersonaModal",
    SelectTagsModal: "SelectTagsModal",
  },
  monthList: [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ],
  dayList: [
    { label: "01", value: "01" },
    { label: "02", value: "02" },
    { label: "03", value: "03" },
    { label: "04", value: "04" },
    { label: "05", value: "05" },
    { label: "06", value: "06" },
    { label: "07", value: "07" },
    { label: "08", value: "08" },
    { label: "09", value: "09" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "28", value: "28" },
    { label: "29", value: "29" },
    { label: "30", value: "30" },
    { label: "31", value: "31" },
  ],
  evenDayList: [
    { label: "01", value: "01" },
    { label: "02", value: "02" },
    { label: "03", value: "03" },
    { label: "04", value: "04" },
    { label: "05", value: "05" },
    { label: "06", value: "06" },
    { label: "07", value: "07" },
    { label: "08", value: "08" },
    { label: "09", value: "09" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "28", value: "28" },
    { label: "29", value: "29" },
    { label: "30", value: "30" },
  ],
  genderArray: [
    { label: "Male", value: "1" },
    { label: "Female", value: "2" },
    // { label: "Other", value: "3" },
  ],
  communityTypeArray: [
    {
      label: "Public",
      value: "1",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
    },
    {
      label: "Private",
      value: "2",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
    },
    // { label: "Other", value: "3" },
  ],
  followArray: [{ label: "On", value: "on" }],
  privacySafety: [{ label: "Off", value: "off" }],
  tags_PostModal: [
    { label: "twitter +", value: "1" },
    { label: "elon musk +", value: "2" },
    { label: "deadpool +", value: "3" },
    { label: "design +", value: "4" },
    { label: "product +", value: "5" },
    { label: "deadpool +", value: "6" },
    { label: "image +", value: "7" },
  ],
  followingFollowersTabs: [
    {
      label: "Following",
      value: "following",
    },
    { label: "Followers", value: "followers" },
  ],
  Receive_Pay: [
    { label: "To Pay", value: 2 },
    { label: "To Receive", value: 1 },
  ],
  ServiceAddRadio: [
    { label: "Service Center", value: "Service Center" },
    { label: "Own Workshop", value: "Own Workshop" },
  ],
  expenseCategory: [
    { label: "Goods", value: "Goods" },
    { label: "Services", value: "Services" },
  ],
  PaymentAddRadio: [
    { label: "Full Payment", value: 2 },
    { label: "Part Payment", value: 1 },
  ],
  TypeOfCategoryRadio: [
    { label: "Fixed", value: 1 },
    { label: "Daywise", value: 2 },
    { label: "% of Revenue", value: 3 },

  ],
  GstAddRadio: [
    { label: "GST Charged", value: 1 },
    { label: "Without GST", value: 0 },
  ],
  MoneyRadio: [
    { label: "Add Money", value: 1 },
    { label: "Reduce Money", value: 2 },
  ],
  BalancesRadio: [
    { label: "(+) Balance", value: 1 },
    { label: "(-) Balance", value: 2 },
  ],
  LR_loads: [
    { label: "Loads", value: 1 },
    // { label: "Dispatch Empty", value: 0 },// by rohit sir
  ],
  itemParts: [
    { label: "Add Parts", value: 1 },
    { label: "Add Service", value: 2 },
    // { label: "Tyre", value: 3 },
    // { label: "Battery", value: 4 },
  ],
  itemPartsTypes: [
    { label: "Multiple Parts", value: 1, bottomPara: "For Items Like Same Oil, Filters These can have Save Item Number" },
    { label: "Single Part", value: 0, bottomPara: "For Items Like Unique Item Number (Tyre, Battery) This cant have same Item Numbers" },
  ],
  dispatchPermissions: [
    { name: "lr_mandatory", label: "Add LR Mandatory" },
    { name: "eway_bill_mandatory", label: "Add Eway Bill Mandatory" },
    { name: "freight_mandatory", label: "Add Freight Mandatory" },
  ],
  chargeGST: [
    { label: "Forward charge mechanism (FCM)", value: 1 },
    { label: "Reverse charge mechanism (RCM)", value: 2 },
  ],
  listBar: [
    { label: "Party Detail", value: "partydetail" },
    { label: "Lorry Receipt", value: "lr" },
    { label: "Invoice", value: "invoice" },
    { label: "Ledger(Statement)", value: "ledger" },
    { label: "Units", value: "units" },
    { label: "Contract", value: "contact" },
    { label: "Rate", value: "rate" },
    { label: "Settings", value: "settings" },
  ],
  addPartyTabs: [
    { id: 1, title: "Address", value: "address" },
    { id: 2, title: "Tax Info", value: "tax_info" },
    { id: 3, title: "Other Details", value: "other" },
  ],
  addBranchTabs: [
    { id: 1, title: "Address", value: "address" },
    { id: 2, title: "Tax Info", value: "tax_info" },
    { id: 3, title: "Others", value: "ohters" },
  ],
  workshopServiceTabs: [
    { id: 1, title: "All Servicing", value: "all_servicing" },
    { id: 2, title: "Service Center ", value: "service_center " },
    { id: 3, title: "Self Servicing", value: "self_servicing" },
  ],
  addOwnDriver: [
    { id: 1, title: "Address", value: "address" },
    { id: 2, title: "Documents", value: "documents" },
  ],
  addMarketDriver: [
    { id: 1, title: "Address", value: "address" },
    { id: 2, title: "Documents", value: "documents" },
  ],
  vehicleOwnership: [
    { label: "Own", value: 1 },
    { label: "Market", value: 2 },
    { label: "Leased", value: 3 },
  ],
  vehicleOwnershipTxn: [
    { label: "Own", value: 1 },
    { label: "Leased", value: 3 },
  ],
  vehicleOwnershipService: [
    { label: "Own", value: 1 },
  ],
  vehicleImgTabs: [
    { id: 1, title: "Address", value: "address" },
    { id: 2, title: "Tax Info", value: "tax_info" },
    { id: 3, title: "Other Details", value: "other" },
  ],
  tripDetailsTabs: [
    { id: 1, title: "Trip Details", value: "trip_details" },
    { id: 2, title: "Freight", value: "freight" },
    { id: 3, title: "Party Freight", value: "consignor_freight" },
    { id: 7, title: "Inter Firm", value: "inter_firm" },
    { id: 4, title: "Revenue", value: "revenue" },
    { id: 5, title: "GPS", value: "gps" },
    { id: 6, title: "SIM Tracking", value: "sim_tracking" },
  ],
  gpsDetailsTabs: [
    { id: 1, title: "Summary", value: "gps_summary" },
    { id: 2, title: "Running History", value: "running_history" },
    { id: 3, title: "Timeline", value: "timeline" },
    { id: 4, title: "Stoppage", value: "stoppage" },
  ],

  gpsTrackerTabs: [
    { id: 0, title: "Summary", value: "history" },
    { id: 1, title: "Running History", value: "running_history" },
    { id: 2, title: "Timeline", value: "timeline" },
    { id: 3, title: "Stoppage", value: "stoppage" },
    { id: 4, title: "History Location", value: "history_location" },
  ],

  newGpsTrackerTabs: [
    { id: 0, title: "Summary", value: "history" },
    { id: 1, title: "Running History", value: "running_history" },
    { id: 2, title: "Timeline", value: "timeline" },
    { id: 3, title: "Stoppage", value: "stoppage" },
  ],

  settingsTabs: [
    { id: 1, title: "Company Profile", value: "company_profile" },
    { id: 2, title: "Branch", value: "branch" },
    { id: 3, title: "Users", value: "users" },
    { id: 4, title: "Roles", value: "roles" },
    { id: 5, title: "Eway Bill Access", value: "eway_bill_access" },
    { id: 6, title: "Subscription", value: "subscription" },
    { id: 7, title: "Route working", value: "route_working" },
  ],
  companyProfile_settingTabs: [
    { id: 1, title: "Profile", value: "profile" },
    { id: 2, title: "Setting", value: "setting" },
    { id: 3, title: "Invoice Format", value: "invoice_format" }
  ],
  firmDetails_Tabs: [
    { id: 1, title: "Profile", value: "profile" },
    { id: 2, title: "Setting", value: "setting" },
    { id: 3, title: "Bank", value: "bank" },
  ],
  branchSettingTabs: [
    { id: 1, title: "Profile", value: "profile" },
    { id: 2, title: "LR Format", value: "lr_format" },
    { id: 3, title: "Indent", value: "indent" },
    { id: 4, title: "Custom Field", value: "custom_field" },
    { id: 5, title: "Settings", value: "settings" },
    { id: 6, title: "Eway Bill Configuration", value: "eway_bill_configuration" }
  ],
  driverTabs: [
    { id: 1, title: "Own Driver", value: "own_driver" },
    { id: 2, title: "Market Driver", value: "market_driver" },
  ],
  walletTabs: [
    { id: 1, title: "Transaction", value: "transaction" },

  ],
  dashboardTabs: [
    { id: 1, title: "Dashboard", value: "dashboard" },
    { id: 2, title: "Vehicle Dashboard", value: "vehicle_dashboard" },
    // { id: 3, title: "GPS", value: "gps_timeline" },
    { id: 4, title: "GPS", value: "new_gps_timeline" },
  ],
  dashboardTabsPermission: [
    { id: 1, title: "Dashboard", value: "dashboard" },
  ],
  truckDocumentTabs: [
    { id: 1, title: "Documents Overview", value: "documents_overview" },
    { id: 2, title: "Vehicle Documents", value: "vehicle_documents" },
  ],
  accountTransactionTabs: [
    { id: 1, title: "Expenses", value: "expenses" },
    { id: 2, title: "Servicing", value: "servicing" },
    { id: 3, title: "EMI", value: "emi" },
    { id: 4, title: "Documents", value: "documents" },
    { id: 5, title: "Salary", value: "salary" },
    { id: 6, title: "Purchase", value: "purchase" },
    { id: 7, title: "Pay Claim", value: "pay_claim" },
    { id: 8, title: "Charge Claim", value: "charge_claim" },
  ],
  transactionExpensesTabs: [
    { id: 1, title: "Invoice Preview", value: "invoice_preview" },
    { id: 2, title: "Payments", value: "payments" },
  ],
  summryDocsTabs: [
    { id: 1, title: "Summary View", value: "summary_view" },
    { id: 2, title: "Detailed View", value: "detailed_view" },
  ],
  consignorDetailsTabs: [
    { id: 1, title: "Party Detail", value: "partydetail" },
    // { id: 11, title: "Lr", value: "lr" },
    { id: 2, title: "Lorry Receipt", value: "lr" },
    { id: 3, title: "Invoice", value: "invoice" },
    { id: 4, title: "Ledger(Statement)", value: "ledger" },
    { id: 5, title: "Units", value: "units" },
    { id: 6, title: "Contract", value: "contact" },
    { id: 7, title: "Rate", value: "rate" },
    { id: 8, title: "Settings", value: "settings" },
    { id: 9, title: "OtherSettings", value: "OtherSetting" },
    { id: 10, title: "Location", value: "Location" },
  ],
  consigneeDetailsTabs: [
    { id: 1, title: " Details", value: "details" },
    { id: 2, title: "Settings", value: "setting" }
  ],
  branchDetailsTabs: [
    { id: 1, title: "Branch Details", value: "details" },
    { id: 2, title: "Settings", value: "setting" },
    { id: 3, title: "LR Format", value: "lr_format" },
    { id: 4, title: "Eway Bill Integration", value: "eway_bill_integration" },
  ],
  supplierDetailsTabs: [
    { id: 1, title: "Supplier Detail", value: "supplier_detail" },
    { id: 2, title: "Trips", value: "trips" },
    { id: 3, title: "Payments", value: "payments" },
    { id: 4, title: "Ledger(Statement)", value: "ledger" },
    { id: 5, title: "Settings", value: "setting" },
  ],
  unitDetailsTabs: [
    { id: 1, title: "Details", value: "details" },
    { id: 2, title: "Settings", value: "setting" }
  ],
  driverDetailsTabs: [
    { id: 1, title: "Driver Detail", value: "driver_detail" },
    { id: 2, title: "Ledger(Statement)", value: "ledger" },
  ],
  driverDetailsTabsForMarket: [
    { id: 1, title: "Driver Detail", value: "driver_detail" },
    // { id: 2, title: "Ledger(Statement)", value: "ledger" },
  ],
  paymentDetailsTabs: [
    { id: 1, title: "Pending", value: "pending" },
    { id: 2, title: "Hold", value: "hold" },
    { id: 3, title: "Approved", value: "approved" },
    { id: 4, title: "Rejected", value: "rejected" },
    { id: 5, title: "Completed", value: "completed" },
  ],
  activeArray: {
    0: "InActive",
    1: "Active",
  },
  dueDateArray: [
    { label: "15 Days before", value: 15 },
    { label: "30 Days before", value: 30 },
    { label: "45 Days before", value: 45 },
    { label: "60 Days before", value: 60 },
  ],
  tripDispatchDetailsTabs: [
    { id: 1, title: "All", value: "all" },
    { id: 2, title: "Draft", value: "draft" },
    { id: 3, title: "InTransit", value: "intransit" },
    { id: 4, title: "Delivered", value: "delivered" },
    { id: 5, title: "Cancelled", value: "cancelled" },
  ],
  billRaiseTabs: [
    { id: 1, title: "Total due", value: "total_due" },
    { id: 2, title: "Over due", value: "over_due" },
    { id: 3, title: "Completed", value: "complated" },
  ],
  topBillRaiseTabs: [
    { id: 1, title: "Invoice", value: "invoice" },
    { id: 2, title: "Pending LR", value: "pending_lr" },
    { id: 3, title: "Claims", value: "claims" },
    { id: 4, title: "Supplementary", value: "supplementary" },
  ],
  billRaiseDetailsTabs: [
    { id: 1, title: "Summary", value: "summary" },
    { id: 2, title: "LR", value: "lr" },
  ],
  addAddressBookTabs: [
    { id: 1, title: "Address", value: "address" },
    { id: 2, title: "Tax Info", value: "tax_info" },
    { id: 3, title: "Other Details", value: "other" },
  ],
  vendersDetailsTabs: [
    { id: 1, title: "Details", value: "details" },
    { id: 2, title: "Ledger(Statement)", value: "ledger" },
  ],
  indentAndBidsDetailTabs: [
    { id: 1, title: "Indent Details", value: "indent_detail" },
    { id: 2, title: "Bids", value: "bids" },
  ],
  bidsStatusTabs: [
    { id: 0, title: "New Bids", value: "new_bids", count: 0 },
    { id: 1, title: "Accepted", value: "accepted_bids", count: 0 },
    { id: 3, title: "Closed", value: "closed_bids", count: 0 },
  ],
  myBidsTabs: [
    { id: 0, title: "Active", value: "active_bids" },
    { id: 1, title: "Accepted", value: "accepted_bids" },
    // { id: 2, title: "Placed", value: "placed_bids" },
    { id: 3, title: "Closed", value: "closed_bids" },
  ],
  // 0 = active, // Pending
  // 1 = accepted, // Accepted
  // 2 = Placed // Rejected
  // 3 = closed // Closed
  myConnectionTabs: [
    { id: 1, title: "All Connections", value: "all_connections" },
    { id: 2, title: "Request", value: "request" },
    { id: 3, title: "Pending", value: "pending" },
    { id: 4, title: "Suggestions", value: "suggestions" },
  ],
  rateTypeObject: {
    1: "Per KOT",
    2: "% Per Invoice",
    3: "Per KG",
    4: "Per QTY",
    5: "Per KMs",
    6: "Flat Rate",
  },
  transactionsDetailsTabs: [
    { id: 1, title: "Transactions", value: 1 },
    { id: 2, title: "Cancelled Transactions", value: 2 },
    { id: 3, title: "Under Approval", value: 3 },
  ],
  manageTripKm: [
    { label: "Mandatory", value: 1 },
    { label: "Non Mandatory", value: 2 },
  ],
  fuelOut_Average: [
    { label: "Editable", value: 1 },
    { label: "Non Editable", value: 2 },
  ],
  fuel_StationDetailsTabs: [
    { id: 1, title: "Details", value: "details" },
    { id: 2, title: "Ledger(Statement)", value: "ledger" },
  ],
  vehicle_DetailsTabs: [
    { id: 1, title: "Documents", value: "documents" },
    // { id: 2, title: "Details", value: "details" },
    { id: 3, title: "Fuel Statement", value: "fuel_statement" },
    { id: 4, title: "GPS", value: "gps" },
    { id: 5, title: "GPS Settings", value: "gps_settings" },
  ],
  vehicle_DetailsTabs1: [
    { id: 1, title: "Documents", value: "documents" },
    { id: 4, title: "GPS", value: "gps" },
    { id: 5, title: "GPS Settings", value: "gps_settings" },
  ],
  vehicleDetailsTabsPermission: [
    { id: 1, title: "Documents", value: "documents" },
    { id: 3, title: "Fuel Statement", value: "fuel_statement" },
    { id: 6, title: "Cards", value: "cards" },
  ],
  vehicle_DetailsTabs1Permission: [
    { id: 1, title: "Documents", value: "documents" },
  ],
  addTransactionsTabs: [
    { id: 1, title: "Documents", value: "documents" },
    { id: 2, title: "Details", value: "details" },
    { id: 3, title: "Fuel Statement", value: "fuel_statement" },
  ],

  connectionRatingsTabs: [
    { id: 1, title: "About", value: "about" },
    { id: 2, title: "Reviews", value: "reviews" },
  ],
  fuel_cardTabs: [
    { id: 1, title: "Summary", value: "summary" },
    { id: 2, title: "Transactions", value: "transactions" },
  ],
  ratingArray: [
    { label: "Any", value: "" },
    { label: "5 Star", value: "5" },
    { label: "4+ Star", value: "4" },
    { label: "3+ Star", value: "3" },
    { label: "2+ Star", value: "2" },
    { label: "1+ Star", value: "1" },
  ],
  addStaffTabs: [
    { id: 1, title: "Address", value: "address" },
    { id: 2, title: "Documents", value: "documents" },
    { id: 3, title: "Other Details", value: "other" },
  ],
  staffDetailsTabs: [
    { id: 1, title: "Staff Detail", value: "staffdetail" },
    { id: 2, title: "Ledger(Statement)", value: "ledger" },
  ],
  invoiceClaimDetailsTabs: [
    { id: 1, title: "Summary", value: "summary" },
    { id: 2, title: "Claims", value: "claims" },
  ],
  invoiceBillRaiseDetailsTabs: [
    { id: 1, title: "Summary", value: "summary" },
    { id: 2, title: "LR", value: "lr" },
  ],
  Tax_type_amount: [
    { label: "Exclusive of Tax", value: 1 },
    { label: "Inclusive of Tax", value: 2 },
  ],
  vehicleUtilizationTabs: [
    { id: 1, title: "Party Detail", value: "partydetail" },
    { id: 2, title: "Lorry Receipt", value: "lr" },
    { id: 3, title: "Invoice", value: "invoice" },
  ],
  vehiclePlaningTabs: [
    { id: 1, title: "Party Detail", value: "partydetail" },
    { id: 2, title: "Lorry Receipt", value: "lr" },
    { id: 3, title: "Invoice", value: "invoice" },
  ],
  vehicleGpsTabs: [
    { id: 1, title: "Party Detail", value: "partydetail" },
    { id: 2, title: "Lorry Receipt", value: "lr" },
    { id: 3, title: "Invoice", value: "invoice" },
  ],
  lrSettingFormatTabs: [
    { id: 1, title: "LR Details", value: "lr_details" },
    { id: 2, title: "Other", value: "other" },
  ],
  InvoiceSettingFormatTabs: [
    { id: 1, title: "Master Setting", value: "master_setting" },
    { id: 2, title: "Fields Setting", value: "fields_setting" },
  ],
  ewayBillTabs: [
    { id: 1, title: "Eway Bill", value: "eway_bill" },
    { id: 2, title: "Eway Bill Checker", value: "eway_bill_checker" },
  ],
  totalWeightType: [
    { label: "Kg", value: 1 },
    { label: "Ltr", value: 3 },
    { label: "Ton", value: 2 },
  ],
  fetchItems: [
    { label: "Only Total", value: 0 },
    { label: "All Items", value: 1 },
  ],
  vehicleDocumentTabs: [
    { id: 1, title: "Documents", value: "documents" },
    { id: 2, title: "Timeline", value: "timeline" },
  ],
  hoursArray: [
    { label: "1 hour", value: 1 },
    { label: "2 hours", value: 2 },
    { label: "3 hours", value: 3 },
    { label: "4 hours", value: 4 },
    { label: "5 hours", value: 5 },
    { label: "6 hours", value: 6 },
    { label: "7 hours", value: 7 },
    { label: "8 hours", value: 8 },
    { label: "9 hours", value: 9 },
    { label: "10 hours", value: 10 },
    { label: "11 hours", value: 11 },
    { label: "12 hours", value: 12 },
    { label: "13 hours", value: 13 },
    { label: "14 hours", value: 14 },
    { label: "15 hours", value: 15 },
    { label: "16 hours", value: 16 },
    { label: "17 hours", value: 17 },
    { label: "18 hours", value: 18 },
    { label: "19 hours", value: 19 },
    { label: "20 hours", value: 20 },
    { label: "21 hours", value: 21 },
    { label: "22 hours", value: 22 },
    { label: "23 hours", value: 23 },
    { label: "24 hours", value: 24 },
  ],
  minutesArray: [
    { label: "1 min", value: 1 },
    { label: "2 min", value: 2 },
    { label: "3 min", value: 3 },
    { label: "4 min", value: 4 },
    { label: "5 min", value: 5 },
    { label: "6 min", value: 6 },
    { label: "7 min", value: 7 },
    { label: "8 min", value: 8 },
    { label: "9 min", value: 9 },
    { label: "10 min", value: 10 },
    { label: "11 min", value: 11 },
    { label: "12 min", value: 12 },
    { label: "13 min", value: 13 },
    { label: "14 min", value: 14 },
    { label: "15 min", value: 15 },
    { label: "16 min", value: 16 },
    { label: "17 min", value: 17 },
    { label: "18 min", value: 18 },
    { label: "19 min", value: 19 },
    { label: "20 min", value: 20 },
    { label: "21 min", value: 21 },
    { label: "22 min", value: 22 },
    { label: "23 min", value: 23 },
    { label: "24 min", value: 24 },
    { label: "25 min", value: 25 },
    { label: "26 min", value: 26 },
    { label: "27 min", value: 27 },
    { label: "28 min", value: 28 },
    { label: "29 min", value: 29 },
    { label: "30 min", value: 30 },
    { label: "31 min", value: 31 },
    { label: "32 min", value: 32 },
    { label: "33 min", value: 33 },
    { label: "34 min", value: 34 },
    { label: "35 min", value: 35 },
    { label: "36 min", value: 36 },
    { label: "37 min", value: 37 },
    { label: "38 min", value: 38 },
    { label: "39 min", value: 39 },
    { label: "40 min", value: 40 },
    { label: "41 min", value: 41 },
    { label: "42 min", value: 42 },
    { label: "43 min", value: 43 },
    { label: "44 min", value: 44 },
    { label: "45 min", value: 45 },
    { label: "46 min", value: 46 },
    { label: "47 min", value: 47 },
    { label: "48 min", value: 48 },
    { label: "49 min", value: 49 },
    { label: "50 min", value: 50 },
    { label: "51 min", value: 51 },
    { label: "52 min", value: 52 },
    { label: "53 min", value: 53 },
    { label: "54 min", value: 54 },
    { label: "55 min", value: 55 },
    { label: "56 min", value: 56 },
    { label: "57 min", value: 57 },
    { label: "58 min", value: 58 },
    { label: "59 min", value: 59 },
    { label: "60 min", value: 60 },
  ],
  billRaiseType: {
    1: "Freight + Claims",
    2: "Freight",
    3: "Claims",
    4: "Other"
  },
  contractFreight: [
    { label: "Visible", value: 1 },
    { label: "Editable", value: 2 },
    { label: "Not Visible", value: 0 },
  ],
  USABILITY_CONFIG_TYPES: {
    LR: 1,
    TRIP: 2,
    EWAY_FETCH: 3,
    EWAY_EXTEND: 3,
    EWAY_FETCH_DISTENCE: 5,
    CONNECT_WITH_TRANSPORTER: 6,
    CALL_TRANSPORTERS: 7,
    LOAD_POST_IN_MARKET: 8,
    CALL_FOR_LOAD: 9,
    BID_PLACE_ON_LOAD: 10,
    FETCH_VEHICLE_DOCUMENT: 11,
    EXTEND_EWAY_NOTIFICATION: 12,
    PAYMENT_TRANSACTION_NOTIFICATION: 13,
    VEHICLE_GPS: 14,
    ROUTE_OPTIMIZATION: 15,
    DRIVER_LOCATION_TOTAL: 16,
    DRIVER_LOCATION_TRIP: 17,

  },

  // constants/permissionTemplates.js

  PERMISSION_TEMPLATES: {
    // Chargeable Actions (message_type: 1)
    1: {
      1: {
        image: Images.ebillExtImg,
        title: "Chargeable First Template",
        description: "You can only add 1 user(s) (including yourself) to your plan. Add more users.",
        callToAction: "Buy a",
        highlight: "Pro Plan",
        features: [
          "Add Eway Bill, Fetch all Item details",
          "Extend Eway Bill from Web & Mobile",
          "Auto Extension of Eway Bill at set time"
        ],
        icon: Images.crownIcon.default,
      },
      2: {
        image: Images.ebillExtImg,
        title: "Chargeable Second Template",
        description: "This feature is locked. Upgrade to automate your invoices.",
        callToAction: "Unlock with",
        highlight: "Business Plan",
        features: [
          "Auto-create invoices from Excel/CSV",
          "Sync with accounting software",
          "Send reminders automatically"
        ],
        icon: Images.crownIcon.default,
      },
      3: {
        image: Images.ebillExtImg,
        title: "Chargeable Third Template",
        description: "File GST returns directly from the app.",
        callToAction: "Upgrade to",
        highlight: "Premium Plan",
        features: [
          "e-Sign enabled filing",
          "Auto-fetch GSTR-1/3B",
          "Team collaboration on filings"
        ],
        icon: Images.crownIcon.default,
      }
    },

    // Inactive Account (message_type: 2)
    2: {
      1: {
        image: Images.ebillExtImg,
        title: "Inactive Template first",
        description: "Your account has been suspended due to inactivity.",
        callToAction: "Contact",
        highlight: "Support",
        features: [],
        icon: Images.warningIcon,
      },
      2: {
        image: Images.ebillExtImg,
        title: "Inactive Template second",
        description: "We couldn't process your last payment.",
        callToAction: "Update",
        highlight: "Payment Method",
        features: ["Avoid service interruption", "Regain full access"],
        icon: Images.warningIcon,
      },
      3: {
        image: Images.ebillExtImg,
        title: "Inactive Template Third",
        description: "Complete your KYC to continue using the service.",
        callToAction: "Verify Now",
        highlight: "",
        features: ["Submit documents", "Get verified in 24 hrs"],
        icon: Images.infoIcon,
      }
    },

    // Upgrade Required (message_type: 3)
    3: {
      1: {
        image: Images.ebillExtImg,
        title: "Upgrade Template first",
        description: "You've reached the limit of your current plan.",
        callToAction: "Upgrade to",
        highlight: "Pro Plan",
        features: [
          "Unlimited users",
          "Advanced analytics",
          "Priority support"
        ],
        icon: Images.crownIcon.default,
      },
      2: {
        image: Images.ebillExtImg,
        title: "Upgrade Template second",
        description: "Collaborate with your team seamlessly.",
        callToAction: "Upgrade to",
        highlight: "Team Plan",
        features: [
          "Team roles & permissions",
          "Shared templates",
          "Audit logs"
        ],
        icon: Images.crownIcon.default,
      },
      3: {
        image: Images.ebillExtImg,
        title: "Upgrade Template third",
        description: "Connect your apps and automate workflows.",
        callToAction: "Upgrade to",
        highlight: "Enterprise Plan",
        features: [
          "Full API access",
          "Webhooks",
          "SLA support"
        ],
        icon: Images.crownIcon.default,
      }
    }
  },
  tripCreationItems: [
    { label: "On", value: true },
    { label: "Off", value: false },
  ],
  addressBokkDetailsTabs: [
    { id: 1, title: "Settings", value: "setting" }
  ],
  consignorBaseTabs: [
    { id: 1, title: "Party Detail", value: "partydetail" },
    { id: 2, title: "Lorry Receipt", value: "lr" },
    { id: 3, title: "Invoice", value: "invoice" },
    { id: 4, title: "Ledger(Statement)", value: "ledger" },
    { id: 5, title: "Units", value: "units" },
    { id: 6, title: "Contract", value: "contact" },
    { id: 7, title: "Rate", value: "rate" },
    { id: 8, title: "Settings", value: "settings" },
    { id: 9, title: "OtherSettings", value: "OtherSetting" },
    { id: 10, title: "Location", value: "Location" },
  ],
  interFirmBaseTabs: [

    { id: 1, title: "Ledger", value: "ledger" },
    { id: 2, title: "Company Trip", value: "Company_Trip" },

  ],
  ActionTypeArray: [
    { value: 2, label: "Against LR" },
    { value: 1, label: "Against Invoice" },
  ],
  typeArray1: [
    { id: 1, name: "Freight + Claims" },
    { id: 2, name: "Freight" },
    { id: 3, name: "Claims" },
    { id: 4, name: "Other" }
  ],
  typeArray2: [
    { id: 1, name: "Freight + Claims" }
  ],
  fastDetailsTabs: [
    { id: 1, title: "All", value: "" },
    { id: 2, title: "Debit", value: "D" },
    { id: 3, title: "Credit", value: "C" },
  ],
  invoiceDetailsSummmaryTabs: [
    // { id: 1, label: "All", value: "0" },
    { id: 1, label: "Invoice", value: "1" },
    { id: 2, label: "LR", value: "2" },
  ],
  ActionStore: [
    { label: "Active", value: 1 },
    { label: "In Active", value: 3 },
  ],
  languageArray: [
    {
      label: "English",
      value: "en",
      iso_code: "en"
    },
    {
      label: "हिन्दी",
      value: "hi",
      iso_code: "hi"
    },
    {
      label: "मराठी",
      value: "mr",
      iso_code: "mr"
    },
    {
      label: "ગુજરાતી",
      value: "gu",
      iso_code: "gu"
    },
    {
      label: "ಕನ್ನಡ",
      value: "kn",
      iso_code: "kn"
    },
    {
      label: "తెలుగు",
      value: "te",
      iso_code: "te"
    },
    {
      label: "தமிழ்",
      value: "ta",
      iso_code: "ta"
    },
    {
      label: "മലയാളം",
      value: "ml",
      iso_code: "ml"
    },
    {
      label: "اردو",
      value: "ur",
      iso_code: "ur"
    }
  ],
  TaxPerct: [
    { label: '5 %', value: 5 },
    { label: '10 %', value: 10 }
  ],
  invoiceDueDateArray: [
    { label: "1 Day", value: 1 },
    { label: "7 Days", value: 7 },
    { label: "10 Days", value: 10 },
    { label: "15 Days", value: 15 },
    { label: "30 Days", value: 30 },
    { label: "45 Days", value: 45 },
    { label: "Custom", value: '' },
  ],
  isPaymentKey: [
    { label: "Full Payment", value: 0 },
    { label: "Part Payment", value: 1 },
  ],
  billStatus_bill: [
    { label: "Pending", value: 1 },
    { label: "Complete", value: 2 },
    { label: "Partially Paid", value: 3 },
  ],
  isServiceType: [
    { label: "Items", value: 1 },
    { label: "Services", value: 2 },
  ],
  isMarkType: [
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ],
  serviceOptions: [
    { value: 'Active', label: 'Active', color: '#0d0367ff', bgColor: '#ECFDF5' },
    { value: 'Completed', label: 'Mark Complete', color: '#059669', bgColor: '#ECFDF5' },
    { value: 'Add Reminder', label: 'Add Reminder', color: '#72747aff', bgColor: '#F9FAFB' },
    { value: 'Add Reminder + Expense', label: 'Add Reminder + Expense', color: '#2563EB', bgColor: '#EFF6FF' },
    { value: 'Delete', label: 'Delete', color: '#ff0404ff', bgColor: '#ECFDF5' },
  ],

  FASTAG_STATUS_OPTIONS: [
    { label: "All", value: null },
    { label: "Closed", value: 0 },
    { label: "Active", value: 1 },
    { label: "Blocked", value: 2 },
  ],

  AUTO_RECHARGE_OPTIONS: [
    { label: "All", value: null },
    { label: "On", value: true },
    { label: "Off", value: false },
  ],
  SERIES_PARAMETER: [
    { id: 1, name: 'payment_voucher', label: 'Payment Voucher' },
    { id: 2, name: 'payment_receipt', label: 'Payment Receipt' },
    { id: 3, name: 'general_expense', label: 'General Expense' },
    { id: 4, name: 'general_receipt', label: 'General Receipt' },
    { id: 5, name: 'vehicle_expense', label: 'Vehicle Expense' },
    { id: 6, name: 'salary_expense', label: 'Salary Expense' },
    { id: 7, name: 'emi_expense', label: 'EMI Expense' },
    { id: 8, name: 'vehicle_document', label: 'Vehicle Document' },
    { id: 9, name: 'purchase_bill', label: 'Purchase Bill' },
    { id: 10, name: 'charge_claim', label: 'Charge Claim' },
    { id: 11, name: 'pay_claim', label: 'Pay Claim' },
  ],
  TYPE_KEY_MAP: {
    1: 'payment_voucher',
    2: 'payment_receipt',
    3: 'general_expense',
    4: 'general_receipt',
    5: 'vehicle_expense',
    6: 'salary_expense',
    7: 'emi_expense',
    8: 'vehicle_document',
    9: 'purchase_bill',
    10: 'charge_claim',
    11: 'pay_claim',
  },
  m_type: {
    party: 1,
    supplier: 2,
    address_book: 3,
    unit: 4,
    consignee: 5,
    vehicle: 6,
    vendors: 7,
    fuel_station: 8,
    branch: 9,
    staff: 10,
    own_driver: 11,
    market_driver: 12,
  },
  typeName: {
    1: 'Party',
    2: 'Supplier',
    3: 'Address book',
    4: 'Unit',
    5: 'Consignee',
    6: 'Vehicle',
    7: 'Vendors',
    8: 'Fuel Station',
    9: 'Branch',
    10: 'Staff',
    11: 'Own Driver',
    12: 'Market Driver'
  },
  tnxName2: {
    1: `consignor`,
    2: `supplier`,
    7: `vendors`,
    8: `fuel_station`,
    10: `staff`, // accounting
    11: `driver`,
  },
  tnxName3: {
    1: 2,
    2: 1,
    3: 11,
    4: 7,
    5: 8,
    8: 10,
  },
  Key: {
    lr: 'LR Creation',
    trip: 'Trip Creation',
    addressbook: 'Addressbook Creation',
    consignee: 'Consignee Creation',
    branch: 'Branch Creation',
    party: 'Party Creation',
    fuel_station: 'Fuel Station Creation',
    market_driver: 'Market Driver Creation',
    own_driver: 'Own Driver Creation',
    staff: 'Staff Creation',
    supplier: 'Supplier Creation',
    vendor: 'Vendor Creation',
    unit: 'Unit Creation',
    indent: 'Indent Creation',
    vehicle: 'Vehicle Creation',
    eway_bill: 'Eway Bill Creation',
    purchase_bill: 'Purchase Bill Creation',
    servicing: 'Servicing Creation',
    part_category: 'Part Category Creation',
    items: 'Items Creation',
  },

  // Dummy Firm List Data for Testing
  // Use this in your component for testing firm-based structure

  dummyFirmList: [
    {
      "responseCode": 200,
      "responseMessage": "",
      "data": {
        "user": {
          "user_id": {
            "_id": "67eb7a166894684905d6a702",
            "mobile_no": 8889114443
          },
          "company_id": {
            "_id": "693a9a2ed2524fb4079bdea6",
            "company": "Ram Group"
          },
          "user_type": 2,
          "active": 1,
          "is_deleted": 0,
          "role_id": {
            "_id": "693a9a2ed2524fb4079bdeba",
            "role_name": "Manager"
          },
          "consignor_group_id": {
            "_id": "693a9a2ed2524fb4079bdec6",
            "name": "Default"
          },
          "vehicle_group_id": {
            "_id": "693a9a2ed2524fb4079bdec8",
            "name": "Default"
          },
          "company_user_name": "Arjun Prjapat",
          "email_id": "",
          "web_or_mobile": 0,
          "allow_all_branch": 0,
          "branch_list": [
            {
              "branch_id": "693a9a2ed2524fb4079bdeaf"
            },
            {
              "branch_id": "693ac33ba0b6b27c2e75773e"
            },
            {
              "branch_id": "693beecc166cb22d3ca2f577"
            },
            {
              "branch_id": "693bef565e0846403bc6717d"
            }
          ],
          "allow_all_account": 0,
          "account_list": [
            {
              "category_id": 1,
              "sub_category_id": 3,
              "account_id": 21,
              "selection": 1,
              "view": 1,
              "create": 1,
              "edit": 1,
              "delete": 1,
              "trip_payment_approval": 0,
              "expenses_approval": 0
            }
          ],
          "trip_payment_approval": 0,
          "expenses_approval": 0,
          "createdAt": "2025-12-12T09:44:14.207Z",
          "updatedAt": "2025-12-12T10:32:54.808Z",
          "firm_list": [
            {
              "firm_id": {
                "_id": "693a9a2ed2524fb4079bdeac",
                "firm": "Ram Group"
              },
              "branch_list": [
                {
                  "_id": "693a9a2ed2524fb4079bdeaf",
                  "branch": "Ram Group",
                  "selection": 0
                },
                {
                  "_id": "693beecc166cb22d3ca2f577",
                  "branch": "Branch 901",
                  "selection": 0
                },
                {
                  "_id": "693bef565e0846403bc6717d",
                  "branch": "Branch 902",
                  "selection": 0
                }
              ],
              "account_list": [
                {
                  "category_id": 1,
                  "sub_category_id": 3,
                  "account_id": 21,
                  "selection": 1,
                  "view": 1,
                  "create": 1,
                  "edit": 1,
                  "delete": 1,
                  "trip_payment_approval": 0,
                  "expenses_approval": 0,
                  "sub_category_name": "Cash",
                  "account_name": "Petty Cash"
                }
              ]
            },
            {
              "firm_id": {
                "_id": "693ac33ba0b6b27c2e75773b",
                "firm": "Laxman"
              },
              "branch_list": [
                {
                  "_id": "693ac33ba0b6b27c2e75773e",
                  "branch": "Laxman",
                  "selection": 0
                }
              ],
              "account_list": [
                {
                  "category_id": 1,
                  "sub_category_id": 3,
                  "account_id": 21,
                  "selection": 1,
                  "view": 1,
                  "create": 1,
                  "edit": 1,
                  "delete": 1,
                  "trip_payment_approval": 0,
                  "expenses_approval": 0,
                  "sub_category_name": "Cash",
                  "account_name": "Petty Cash"
                }
              ]
            }
          ]
        }
      }
    }
  ]
};


export const genExpensedata = {
  invoiceNo: 'EXP2025-01',
  firm: {
    name: 'Firm Name will Come here',
    address: 'Shop No. 2 Near Ram Mandir, Road, Indore',
    contact: '7565614634',
  },
  vendor: {
    name: 'Vendor Name will come here',
    address: 'Shop No. 2 Near Ram Mandir, Road, Indore',
    contact: '7565614634',
    gstin: '19AAACT2727Q1ZT',
  },
  meta: {
    date: '9 Feb 2026',
    billNumber: '2432432434',
    placeOfSupply: 'Madhya Pradesh',
  },
  items: [
    {
      description: 'Description will come here',
      category: 'Expense Category',
      hsn: '123133', qty: 10, rate: 500,
      discount: 500, discountPercent: 1,
      tax: 4500, cgst: 500, cgstPercent: 9,
      sgst: 500, sgstPercent: 9, total: 4500,
    },
  ],
  totals: { qty: 10, rate: 500, discount: 500, tax: 500, cgst: 500, sgst: 500, total: 500 },
  amountInWords: 'Three Lakh Seventy Seven Thousand Two Hundred Fifty Rupees Only',
  termsConditions: 'Terms & Conditions',
  summary: {
    taxableAmount: 500, discount: 500, taxAmount: 500,
    totalInvoiceAmount: 500, paymentReceived: 500, balanceDue: 500,
  },
  currentPage: 1,
  totalPages: 2,
};